import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET google-fonts/v1/families
 */
export function fetch(query, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('google-fonts/v1/families', {
    query
  });
}

/**
 * GET google-fonts/v1/families/{family}
 */
export function fetchFont(name, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`google-fonts/v1/families/${name}`);
}

/**
 * GET content/fonts/v1/by-asset-path/{path}
 */

export function fetchCustomFontsByAsset({
  family,
  path
}, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`content/fonts/v1/by-asset-path/${path}`, {
    query: {
      family
    }
  });
}

/**
 * GET /branding/v1/fonts-with-variants
 */

export function fetchCustomFonts({
  brandKitId
}, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`/branding/v1/fonts-with-variants`, Object.assign({}, brandKitId && {
    query: {
      brandKitId
    }
  }));
}

/**
 * GET branding/v1/fonts-with-variants/{id}
 */

export function fetchCustomFont(id, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`branding/v1/fonts-with-variants/${id}`);
}

/**
 * GET /branding/v1/fonts-meta
 */

export function fetchBrandFonts(brandKitId, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`/branding/v1/font-meta`, Object.assign({}, brandKitId && {
    query: {
      brandKitId
    }
  }));
}